import { useEffect, useState } from "react";
import IconsStatus from "./IconStatus";
import { useTranslation } from "react-i18next";

/**
 * Composant qui permet de filtrer par type ex : d'équipements Meraki
 * @param {array} data - données à filtrer
 * @param {object} countObject - un objet avec une clé "name" et un titre, exemple : const statusCount = {name: "Status"}
 * @param {string} objectKey - nom de la clé pour trouver la valeur dans les données
 * @param {string} secondKey - si data[objectKey] est un objet, ajouter une secondKey
 * @param {function} setValueType - fonction pour filtrer les données lorsque l'utilisateur clique
 * @param {boolean} click - active la fonction onClick pour filtrer les données
 * @param {boolean} resetValue - état de réinitialisation du filtre
 * @param {boolean} click - permet de réinitialiser les filtres
 */

export default function Globalview({
  data,
  countObject,
  objectKey,
  secondKey,
  setValueType,
  click,
  resetValue,
  setResetValue,
}) {
  const [globalView, setGlobalView] = useState([]);
  const [activeFilter, setActiveFilter] = useState(null);
  const {t} = useTranslation();

  //Permet de définir le type d'équipement qui est considérer comme un switch
  const consolidateSwitch = (countObject) => {
    const switchTypes = ['switch', 'stack', 'l3Switch', 'controller'];
    const totalSwitches = switchTypes.reduce((total, switchType) => {
      if (countObject[switchType]) {
        total += countObject[switchType];
        delete countObject[switchType];
      }
      return total;
    }, 0);

    countObject['switch'] = totalSwitches;
    return countObject;
  };

  // Obtenir le nombre d'appareils en fonction de leur statut
  const getGlobalView = () => {
    data.forEach((item) => {
      let keyToDisplay = secondKey ? item[objectKey][secondKey] : item[objectKey];
      if (objectKey === "statuscode") {
        switch (true) {
          case keyToDisplay === "5":
            countObject["Résolu"]++;
            break;

          case keyToDisplay !== "5":
            countObject["Non résolu"]++;
            break;
        }
      } else {
        if (countObject[keyToDisplay]) {
          countObject[keyToDisplay]++;
        } else {
          countObject[keyToDisplay] = 1;
        }
      }
    });
    
    if(objectKey === "deviceType") {
      countObject = consolidateSwitch(countObject);
    }
    setGlobalView([countObject]);
  };

  useEffect(() => {
    if (resetValue === true) {
      setActiveFilter(null);
      setResetValue(null);
    }
  }, [resetValue]);

  const handleFilterClick = (key) => {
    setValueType(key);
    setActiveFilter(key);
  };

  useEffect(() => {
    getGlobalView();
  }, [data]);  

  return (
    <>
      {globalView.map((item, index) => (
        <div className="global-view" key={index}>
          <h2> {objectKey === "statuscode" ? t("Statuts des tickets") : `${t(item.name)}`}</h2>
          <div className="global-view_content">
            {/* Conversion de globalView en tableau pour ensuite le mapper et afficher les données */}
            {Object.entries(item).map(([key, number]) => {
              if (key !== "name") {
                return (
                  <div key={key} className="global-view_value">
                    {click ? (
                      <button
                        onClick={() => {
                          handleFilterClick(key);
                        }}
                        className={`button button-white ${activeFilter === key ? 'active-filter' : ''}`}
                      >
                        <IconsStatus value={key} icon />
                        <span className="global-view_value-number">{number}</span>
                      </button>
                    ) : (
                      <>
                        <IconsStatus value={key} icon />
                        <span className="gloabl-view_value-number">{number}</span>
                      </>
                    )}
                  </div>
                );
              }
            })}
          </div>
        </div>
      ))}
    </>
  );
}
